// Analytics Refresh Utility
// Triggers refresh across all analytics components after quiz completion

export const triggerAnalyticsRefresh = (quizData = {}) => {
  console.log(
    "🔄 Triggering analytics refresh after quiz completion",
    quizData
  );

  // 1. Set localStorage flag for dashboard detection
  localStorage.setItem("dashboardNeedsRefresh", "true");

  // 2. Dispatch storage event for cross-tab communication
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: "dashboardNeedsRefresh",
      newValue: "true",
    })
  );

  // 3. Dispatch custom event for same-tab communication
  window.dispatchEvent(
    new CustomEvent("quizCompleted", {
      detail: {
        studentId: quizData.studentId,
        quizId: quizData.quizId,
        subject: quizData.subject,
        topic: quizData.topic,
        score: quizData.score,
        total: quizData.total,
        timestamp: new Date().toISOString(),
      },
    })
  );

  // 4. Dispatch immediate dashboard refresh event
  window.dispatchEvent(
    new CustomEvent("dashboardRefreshNeeded", {
      detail: {
        reason: "quiz_completion",
        timestamp: new Date().toISOString(),
        ...quizData,
      },
    })
  );

  // 5. Force refresh if currently on analytics or dashboard pages
  const currentPath = window.location.pathname;
  if (
    currentPath.includes("/analytics") ||
    currentPath.includes("/progress") ||
    currentPath.includes("/student-dashboard")
  ) {
    console.log(
      "📊 On analytics/dashboard page - triggering immediate refresh"
    );

    // Small delay to ensure backend has processed the quiz
    setTimeout(() => {
      console.log("🔄 Reloading page to show updated data");
      window.location.reload();
    }, 2000);
  }

  console.log(
    "✅ Analytics refresh triggers sent - localStorage flag set, events dispatched"
  );
};
